import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRectangleHorizontalDouble = (props) => /* @__PURE__ */ _jsx("svg", {
	focusable: "false",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	className: "svg-icon",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22 3v8H2V3h20zm-2 2H4v4h16V5zm2 8v8H2v-8h20zm-2 2H4v4h16v-4z"
	})
});
export default SvgRectangleHorizontalDouble;
